export const ACTIVITY_REQUEST = 'ACTIVITY_REQUEST'
export const ACTIVITY_ERROR = 'ACTIVITY_ERROR'
export const ACTIVITY_LIST = 'ACTIVITY_LIST'
export const ACTIVITY_LIST_SUCCESS = 'ACTIVITY_LIST_SUCCESS'
